const addBodyOverlay = () => {
  const detailsElements = document.querySelectorAll('details.header__menu-disclosure');

  const observerCallback = (mutationsList) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        updateBodyClass();
      }
    }
  };

  const observer = new MutationObserver(observerCallback);

  detailsElements.forEach((details) => {
    observer.observe(details, { attributes: true });
  });

  const updateBodyClass = () => {
    const isOpen = Array.from(detailsElements).some((details) => details.hasAttribute('open'));
    if (isOpen) {
      document.body.classList.add('body-overlay');
    } else {
      document.body.classList.remove('body-overlay');
    }
  };

  updateBodyClass();
};

const hideMobileSidebar = () => {
  const hideBttn = document.querySelector('.header__close-sidebar');
  const sidebar = document.querySelector('header-sidebar');
  if (sidebar && hideBttn) {
    hideBttn.addEventListener('click', () => {
      sidebar.hide();
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  addBodyOverlay();
  hideMobileSidebar();
});
